export default __webpack_public_path__ + "static/media/img-completed-mark@2x.a04f61b9.png";